// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"6495cda3","446":"d2f8977f","453":"d15c45c1","851":"9756a6b4","875":"b3903fe9"}[chunkId] + ".chunk.js";
};